export var TRACKING_EVENT;
(function (TRACKING_EVENT) {
    TRACKING_EVENT["GA_LOGIN_EVENT"] = "TrackingEvent.LoginEvent";
    TRACKING_EVENT["GA_ROUTE_EVENT"] = "TrackingEvent.GSRouteEvent";
})(TRACKING_EVENT || (TRACKING_EVENT = {}));
